import { render, staticRenderFns } from "./CourseFolderDetails.vue?vue&type=template&id=2c35fb46&scoped=true"
import script from "./CourseFolderDetails.vue?vue&type=script&lang=js"
export * from "./CourseFolderDetails.vue?vue&type=script&lang=js"
import style0 from "./CourseFolderDetails.vue?vue&type=style&index=0&id=2c35fb46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c35fb46",
  null
  
)

export default component.exports